import { UPDATE_EVENTS_FILTERS } from "./constants";
import { FETCH_CLIENT_DONE } from "../client/constants";
import { SCHEDULED } from "../../constants";

const initialState = {
  filters: {
    clientId: null,
    conferenceId: null,
    sport: 0,
    eventType: 0,
    category: 0,
    tabName: SCHEDULED,
    text: "",
    showEventTypeFilter: false,
    sStartDate: new Date(new Date().setHours(0, 0, 0, 0)),
    sEndDate: new Date(new Date().setDate(new Date().getDate() + 60)),
    oStartDate: new Date(new Date().setDate(new Date().getDate() - 60)),
    oEndDate: new Date()
  }
};

export default (state = initialState, action) => {
  let filters = {};
  switch (action.type) {
    case FETCH_CLIENT_DONE:
      filters = {
        ...state.filters,
        clientId: action.payload.data.id,
        eventType: action.payload.data.features?.ppv ? 0 : 1,
        showEventTypeFilter: !!action.payload.data.features?.ppv
      };
      return {
        ...state,
        filters
      };
    case UPDATE_EVENTS_FILTERS: {
      filters = { ...state.filters, ...action.filters };
      return {
        ...state,
        filters
      };
    }
    default:
      return state;
  }
};
